import type { ComponentProps } from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@shared/lib/utils';

function CardMetric({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div data-slot="card-metric" className={cn('flex flex-col gap-1', className)} {...props} />
  );
}

function CardMetricPrimary({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-metric-primary"
      className={cn('flex shrink-0 items-baseline gap-2', className)}
      {...props}
    />
  );
}

const cardMetricValueVariants = cva('font-medium text-foreground', {
  variants: {
    size: {
      md: 'text-xl leading-tight',
      lg: 'text-4xl/none',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

function CardMetricValue({
  className,
  size,
  ...props
}: ComponentProps<'div'> & VariantProps<typeof cardMetricValueVariants>) {
  return (
    <div
      data-slot="card-metric-value"
      className={cn(cardMetricValueVariants({ size }), className)}
      {...props}
    />
  );
}

function CardMetricSecondary({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-metric-secondary"
      className={cn('text-xs text-muted-foreground', className)}
      {...props}
    />
  );
}

function CardMetricEmphasis({ className, ...props }: ComponentProps<'span'>) {
  return (
    <span
      data-slot="card-metric-emphasis"
      className={cn('font-medium text-foreground', className)}
      {...props}
    />
  );
}

export { CardMetric, CardMetricEmphasis, CardMetricPrimary, CardMetricSecondary, CardMetricValue };
